import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { useNavigationView } from '../../../design-system';
import { mainNav } from '../../navView';
import { ChargePointsList } from './ChargePointsList';

export const ChargePointsListView: React.FC = () => {
  useNavigationView(mainNav);

  return (
    <Switch>
      <Route>
        <ChargePointsList />
      </Route>
    </Switch>
  );
};
